export default "__VITE_ASSET__D8aqyRtJ__"